export const fetchPortifolios = ({ clientID }): Function => (
  state,
  actions,
): Promise<void> => {
  const { api } = state;

  if (state.portifolios.length) return;

  const headers = new Headers({ authorization: state.authorization });

  fetch(`${api}/v1/places/${clientID}/portifolios`, { headers })
    .then(response => response.json())
    .then(({ portifolios }) => actions.setPortifolios({ portifolios }));

  return {
    ...state,
    loadingPortifolios: true,
  };
};
